'use strict';

import { getSecuredFirestore } from './Firestore.js';

const MAX_ITEMS = 100;

var cartDocPromise;
function getCartDoc(userId) {
  if (cartDocPromise == null) {
    cartDocPromise = new Promise(function (resolve, reject) {
      getSecuredFirestore().then(function (firestore) {
        let usersRef = firestore.collection('users');
        let userDoc = usersRef.doc(userId);
        let cartsRef = firestore.collection('carts');
        let cartsQuery = cartsRef.where('userRef', '==', userDoc);
        cartsQuery.get().then(async function (querySnapshot) {
          resolve(querySnapshot.docs[0].ref);
        }).catch(function (e) {
          reject();
        });
      });
    });
  }
  return cartDocPromise;
}

function addItem(userId, productId, amount) {
  return getCartDoc(userId).then((cartDoc) => {
    return cartDoc.get().then((docRef) => {
      let items = docRef.get('items');
      let item = items.find(function (i) {
        return i.productRef.id == productId;
      });

      if (item) {
        let total = item.amount + amount;
        item.amount = Math.max(0, Math.min(MAX_ITEMS, total));
        return cartDoc.update({ items: items }).then(() => cartDoc);
      } else {
        return getSecuredFirestore().then(function (firestore) {
          let productsRef = firestore.collection('products');
          let productRef = productsRef.doc(productId);
          item = { 'productRef': productRef, 'amount': Math.max(0, Math.min(MAX_ITEMS, amount)) };
          items.push(item);
          return cartDoc.update({ items: items }).then(() => cartDoc);
        });
      }
    });
  });
}

export { getCartDoc, addItem, MAX_ITEMS }